import React, { useContext } from 'react';
import { ViewDashboardContext } from '../../shared/entities/view/components/view-dashboard/ViewDashboardContext';
import { ResearchDashboardProp } from '../enums/ResearchDashboardProp';
import { ResearchDashboardDto } from '../interfaces/ResearchDashboardDto';
import ViewDashboardGrid from '../../shared/entities/view/components/view-dashboard/components/ViewDashboardGrid';
import { recentResearchViewOptions } from '../../views/recent-research/constants/recentResearchViewOptions';
import { researchGridCustomColumnsSettings } from '../constants/researchGridCustomColumnsSettings';

const ResearchDashboardResearchGrid: React.FC = () => {
  const context = useContext(ViewDashboardContext);
  const data = context.data as ResearchDashboardDto;

  return (
    <ViewDashboardGrid
      dataTable={data[ResearchDashboardProp.RecentResearch]}
      colIds={recentResearchViewOptions.grid?.idCols}
      isColumnsFitGrid={false}
      customColumnsSettings={researchGridCustomColumnsSettings}
    />
  );
};

export default ResearchDashboardResearchGrid;
